module.exports = __webpack_public_path__ + "img/QglobalLogo.c50232f5.svg";